import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    TextField,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Modal,
    Grid,
    Stack,
    Pagination,
    Checkbox,
  } from "@mui/material";
  
  import CloseIcon from "@mui/icons-material/Close";
  import React, { useEffect, useRef, useState } from "react";
  
  import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
  
  import { useSelector } from "react-redux";
  
  import DatePicker from "react-datepicker";
  import EventIcon from "@mui/icons-material/Event";
  import SearchIcon from "@mui/icons-material/Search";
   
  import Swal from "sweetalert2"; 
import { ModalHeader } from "../../common/modalHeader";
  export default function AppoinmentModal({ open, setOpen,data,setData  }) {
   const arr=["Hair cutting","Shaving"]
    return (
        
      <Modal
        open={open}
        onClose={()=>setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
  
  
  
        <Box
          sx={{
            background: "white",
            width: "40%",
            overflowY: "auto",padding:"10px",
            height: "auto",
            position: "absolute",
            left: "30%",
            top: "10%",
            
          }}
        >
       
          <ModalHeader title={"Services"} 
          onClose={(data)=>{
            setOpen(data)
          }}
          />
  
          <Grid container sx={{ position: "relative",padding:"10px" }}>
  
           {
            arr.map((ele,index)=>{
                return (
                    <React.Fragment>
                         <Grid item xs={10}  >
            <Typography    > {ele}</Typography>
            </Grid>
            <Grid item xs={2}>
                <Checkbox selected={data.findIndex((ele2,index)=>ele2.services==ele)!=-1} onChange={(e)=>{


                    let tempArr=[...data]
                    let indexV=data.findIndex((ele2,index)=>ele2.service==ele)
                    if(indexV==-1){
                        setData([...data,{service:ele}])
                    }
                    else{
                        tempArr.splice(indexV,1)
                        setData(tempArr)
                    }

                }} />
            </Grid>
                    </React.Fragment>
                )
            })
           }
           
          </Grid>
          <Button 

                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "#3695B6",
                  padding: "14px",
                  fontSize: "16px",
                }}

                onClick={()=>{
                    setOpen(false)
                }}
              >
                Done
              </Button>
  
     
        </Box>
      </Modal>
    );
  }
  